import * as React from 'react';

import { getTrafaretsAuctionDataByParamValue } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { CurrencyLimitData } from '../../typings/constants';
import { TrafficVolumeDataItem } from '../../typings/domain';
import { PhraseTrafficForecast } from '../PhraseTrafficFocast/PhraseTrafficForecast';
import {
    TrafaretPhrasePriceEditorPopup,
    TrafaretPhrasePriceEditorPopupSaveValue
} from '../TrafaretPhrasePriceEditorPopup/TrafaretPhrasePriceEditorPopup';

import './PhraseTrafficForecastCell.css';

export interface PhraseTrafficForecastCellProps {
    currency: string;
    bid: number;
    trafficVolumeData: Array<TrafficVolumeDataItem>;
    isSaving: boolean;
    error?: string;
    onSave: (value: TrafaretPhrasePriceEditorPopupSaveValue) => void;
    priceLimit: CurrencyLimitData;
    isGridScrolling: boolean;
}

export interface PhraseTrafficForecastCellState {
    isPopupOpened: boolean;
}

export class PhraseTrafficForecastCell extends React.PureComponent<
    PhraseTrafficForecastCellProps,
    PhraseTrafficForecastCellState
> {
    static getDerivedStateFromProps(nextProps: PhraseTrafficForecastCellProps) {
        if (nextProps.isGridScrolling) {
            return {
                isPopupOpened: false
            };
        }

        return null;
    }

    componentDidUpdate(prevProps: PhraseTrafficForecastCellProps) {
        if (
            (prevProps.isSaving !== this.props.isSaving || prevProps.error !== this.props.error) &&
            !this.props.isSaving &&
            !this.props.error
        ) {
            this.setState({
                isPopupOpened: false
            });
        }
    }

    constructor(props: PhraseTrafficForecastCellProps) {
        super(props);

        this.state = {
            isPopupOpened: false
        };
    }

    render() {
        const { bid, trafficVolumeData, currency, isSaving, onSave, priceLimit } = this.props;
        const { isPopupOpened } = this.state;

        const trafaretsAuctionData = getTrafaretsAuctionDataByParamValue('bid', bid, trafficVolumeData);
        let trafficVolumeValue;

        if (trafaretsAuctionData) {
            trafficVolumeValue = trafaretsAuctionData.trafficVolume;
        }

        return (
            <>
                <div className={'phrase-traffic-forecast-cell'} onClick={this.switchPopupState}>
                    <PhraseTrafficForecast
                        value={trafficVolumeValue}
                        minValue={trafficVolumeData[0].trafficVolume}
                        maxValue={trafficVolumeData[trafficVolumeData.length - 1].trafficVolume}
                        disabled={true}
                    />
                </div>

                {isPopupOpened ? (
                    <TrafaretPhrasePriceEditorPopup
                        priceLimit={priceLimit}
                        initialBid={bid}
                        trafficVolumeData={trafficVolumeData}
                        currency={currency}
                        anchor={this}
                        isPopupOpen={isPopupOpened}
                        isSaving={isSaving}
                        onSave={onSave}
                        onCancel={this.cancel}
                    />
                ) : null}
            </>
        );
    }

    private switchPopupState = () => {
        const { isPopupOpened } = this.state;

        this.setState({
            isPopupOpened: !isPopupOpened
        });
    };

    private cancel = () => {
        this.setState({
            isPopupOpened: false
        });
    };
}
